export default "__VITE_ASSET__Dnu9J4Jq__"